import { put, call, take, takeLeading } from 'redux-saga/effects'
import { refreshTokenService } from '../../api/authentication'
import {
  authenticationRefreshSuccess,
  authenticationRefreshError,
} from '../../reducers/authentication/action'
import { AUTHENTICATION_REFRESH } from '../../reducers/authentication/type'
import { operationSuccess } from '../../reducers/operation/action'
import {
  set as setCookie,
  get as getCookie,
  remove as removeCookie,
} from 'es-cookie'
import { getCookieOptions } from '../../utils/cookie-options'

export const checkFetchingData = state => {
  return state.authentication.refreshTokenBusy
}
/**
 *
 * @param {*} payload
 */
function* refreshSagaFlow(payload) {
  try {
    let refreshToken = getCookie('refreshToken')
    const response = yield call(refreshTokenService, { refreshToken })

    removeCookie('refreshToken')

    setCookie('token', response.data.accessToken, getCookieOptions())
    setCookie('refreshToken', response.data.refreshToken, getCookieOptions())
    setCookie('userId', response.data.userId, getCookieOptions())

    yield put(authenticationRefreshSuccess())

    yield put(operationSuccess())
  } catch (error) {
    yield put(authenticationRefreshError())
    yield put(operationSuccess())
  }
}

/**
 *
 */
export default function* refreshSagaWatcher() {
  const action = yield take(AUTHENTICATION_REFRESH)

  const { payload } = action

  yield takeLeading(AUTHENTICATION_REFRESH, refreshSagaFlow, payload)
  /*   
  yield fork(generalSaga, refreshSagaFlow, payload) */
}
